import { render, staticRenderFns } from "./comfirm2.vue?vue&type=template&id=8780346e&scoped=true"
import script from "./comfirm2.vue?vue&type=script&lang=js"
export * from "./comfirm2.vue?vue&type=script&lang=js"
import style0 from "./comfirm2.vue?vue&type=style&index=0&id=8780346e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8780346e",
  null
  
)

export default component.exports